
      import { signInWithGoogle, signOut, onAuthChange, auth } from '/src/lib/firebase.ts';
      import { getLeaderboard, saveProfile } from '/src/lib/firestore.ts';
      import {
        UPGRADE_MAX_LEVEL, UPGRADE_BONUS_PER_LEVEL,
        UPGRADE_STAT_LABELS, UPGRADE_STAT_ICONS,
        RARITY_UPGRADE_LABELS, RARITY_UPGRADE_COLORS,
        nextUpgradeCost,
      } from '/src/data/upgrades.ts';

      const overlay = document.getElementById('start-overlay');
      const loggedOut = document.getElementById('start-logged-out');
      const loggedIn = document.getElementById('start-logged-in');
      const userImg = document.getElementById('start-user-img');
      const userName = document.getElementById('start-user-name');
      const bestRecordWave = document.getElementById('best-record-wave');
      const leaderboardModal = document.getElementById('leaderboard-modal');
      const leaderboardWave = document.getElementById('leaderboard-wave');
      const meName = document.getElementById('lb-me-name');
      const loginHint = document.getElementById('lb-login-hint');
      const lbList = document.getElementById('lb-list');

      let currentUser = null;
      let selectedStage = 1;

      function getLocalBest() {
        return parseInt(localStorage.getItem('porande-best-wave') || '0', 10);
      }

      function getUP() {
        return parseInt(localStorage.getItem('porande-up') || '0', 10);
      }
      function setUP(v) {
        localStorage.setItem('porande-up', String(v));
      }
      function getUpgrades() {
        try { return JSON.parse(localStorage.getItem('porande-upgrades') || '{}'); }
        catch { return {}; }
      }
      function setUpgrades(u) {
        localStorage.setItem('porande-upgrades', JSON.stringify(u));
      }
      function isStage1Cleared() {
        return localStorage.getItem('porande-stage1-cleared') === '1';
      }

      function refreshUpBadge() {
        document.getElementById('btn-up-badge').textContent = `${getUP()} UP`;
      }
      refreshUpBadge();

      function refreshStageButtons() {
        const cleared = isStage1Cleared();
        const s1 = document.getElementById('stage-1-btn');
        const s2 = document.getElementById('stage-2-btn');
        if (cleared) {
          s2.classList.remove('locked');
        } else {
          s2.classList.add('locked');
          // 스테이지 2의 이름을 잠금 상태로 표기
          s2.querySelector('.stage-name').innerHTML = '🔒 잠김';
        }
        s1.classList.toggle('active', selectedStage === 1);
        s2.classList.toggle('active', selectedStage === 2);
      }
      refreshStageButtons();

      document.getElementById('stage-1-btn').addEventListener('click', () => {
        selectedStage = 1;
        refreshStageButtons();
      });
      document.getElementById('stage-2-btn').addEventListener('click', () => {
        if (!isStage1Cleared()) {
          return; // 잠김
        }
        selectedStage = 2;
        refreshStageButtons();
      });

      function refreshBest() {
        const best = getLocalBest();
        bestRecordWave.textContent = best;
        leaderboardWave.textContent = best;
      }
      refreshBest();

      function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, (c) => ({
          '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
        }[c]));
      }

      function initials(name) {
        if (!name) return '?';
        const t = name.trim();
        return t.charAt(0).toUpperCase();
      }

      function renderLeaderboard(entries) {
        if (!entries || entries.length === 0) {
          lbList.innerHTML = `
            <div class="lb-empty">
              <span class="emoji">🏁</span>
              아직 기록이 없어요<br />
              <span style="opacity:0.7;font-size:11px">첫 번째 기록의 주인공이 되어보세요!</span>
            </div>`;
          return;
        }
        const myUid = currentUser?.uid;
        const html = entries.map((e, i) => {
          const rank = i + 1;
          const medal = rank === 1 ? '🥇' : rank === 2 ? '🥈' : rank === 3 ? '🥉' : `${rank}`;
          const rankClass = `rank-${rank <= 3 ? rank : 'n'}`;
          const meClass = e.uid === myUid ? ' me' : '';
          const avatar = e.photoURL
            ? `<img class="lb-avatar" src="${escapeHtml(e.photoURL)}" alt="" onerror="this.replaceWith(Object.assign(document.createElement('div'), {className:'lb-avatar',textContent:'${escapeHtml(initials(e.displayName))}'}))" />`
            : `<div class="lb-avatar">${escapeHtml(initials(e.displayName))}</div>`;
          return `
            <div class="lb-row ${rankClass}${meClass}">
              <div class="lb-rank">${medal}</div>
              ${avatar}
              <div class="lb-name">${escapeHtml(e.displayName || '익명 트레이너')}</div>
              <div>
                <span class="lb-wave">${e.bestWave}</span><span class="lb-wave-label">W</span>
              </div>
            </div>`;
        }).join('');
        lbList.innerHTML = html;
      }

      async function loadLeaderboard() {
        lbList.innerHTML = `
          <div class="lb-loading">
            <span class="emoji">⚙️</span>
            불러오는 중...
          </div>`;
        const entries = await getLeaderboard(10);
        renderLeaderboard(entries);
      }

      onAuthChange((user) => {
        currentUser = user;
        if (user) {
          loggedOut.style.display = 'none';
          loggedIn.style.display = 'block';
          userName.textContent = user.displayName || '사용자';
          if (user.photoURL) userImg.src = user.photoURL;
          meName.textContent = user.displayName || '사용자';
          loginHint.style.display = 'none';
          // 로그인 시 로컬 최고 기록을 Firestore와 동기화
          const localBest = getLocalBest();
          if (localBest > 0) saveProfile(localBest);
        } else {
          loggedOut.style.display = 'block';
          loggedIn.style.display = 'none';
          meName.textContent = '게스트';
          loginHint.style.display = 'block';
        }
      });

      document.getElementById('btn-google-start').addEventListener('click', async () => {
        await signInWithGoogle();
      });

      document.getElementById('btn-logout-start').addEventListener('click', async () => {
        await signOut();
      });

      document.getElementById('btn-leaderboard-start').addEventListener('click', () => {
        refreshBest();
        leaderboardModal.classList.add('open');
        loadLeaderboard();
      });

      document.getElementById('btn-leaderboard-close').addEventListener('click', () => {
        leaderboardModal.classList.remove('open');
      });

      leaderboardModal.addEventListener('click', (e) => {
        if (e.target === leaderboardModal) {
          leaderboardModal.classList.remove('open');
        }
      });

      // ===== Upgrade Modal =====
      const upgradeModal = document.getElementById('upgrade-modal');
      const upBalanceEl = document.getElementById('up-balance');
      const upListEl = document.getElementById('up-list');
      const STATS = ['attack', 'range', 'speed'];

      function renderUpgrades() {
        const up = getUP();
        const upgrades = getUpgrades();
        upBalanceEl.textContent = up;
        const html = [1, 2, 3, 4, 5, 6].map((r) => {
          const color = RARITY_UPGRADE_COLORS[r];
          const label = RARITY_UPGRADE_LABELS[r];
          const rows = STATS.map((stat) => {
            const key = `${r}_${stat}`;
            const lv = upgrades[key] ?? 0;
            const pct = Math.round(lv * UPGRADE_BONUS_PER_LEVEL * 100);
            const cost = nextUpgradeCost(lv);
            const isMax = lv >= UPGRADE_MAX_LEVEL;
            const canBuy = !isMax && up >= cost;
            const btnHtml = isMax
              ? `<button class="up-buy-btn maxed" disabled>MAX</button>`
              : `<button class="up-buy-btn ${canBuy ? '' : 'disabled'}" data-rarity="${r}" data-stat="${stat}" ${canBuy ? '' : 'disabled'}>${cost} UP</button>`;
            return `
              <div class="up-row">
                <span class="up-stat-icon">${UPGRADE_STAT_ICONS[stat]}</span>
                <span class="up-stat-name">${UPGRADE_STAT_LABELS[stat]}</span>
                <span class="up-stat-meta">
                  <span class="lv">Lv ${lv}/${UPGRADE_MAX_LEVEL}</span>
                  <span class="pct">+${pct}%</span>
                </span>
                ${btnHtml}
              </div>`;
          }).join('');
          return `
            <div class="up-group" style="--group-color: ${color}">
              <div class="up-group-title">${label}</div>
              ${rows}
            </div>`;
        }).join('');
        upListEl.innerHTML = html;

        // Bind buy buttons
        upListEl.querySelectorAll('.up-buy-btn[data-rarity]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const r = parseInt(btn.getAttribute('data-rarity'), 10);
            const stat = btn.getAttribute('data-stat');
            buyUpgrade(r, stat);
          });
        });
      }

      function buyUpgrade(rarity, stat) {
        const up = getUP();
        const upgrades = getUpgrades();
        const key = `${rarity}_${stat}`;
        const lv = upgrades[key] ?? 0;
        if (lv >= UPGRADE_MAX_LEVEL) return;
        const cost = nextUpgradeCost(lv);
        if (up < cost) return;
        setUP(up - cost);
        upgrades[key] = lv + 1;
        setUpgrades(upgrades);
        refreshUpBadge();
        renderUpgrades();
      }

      document.getElementById('btn-upgrade-start').addEventListener('click', () => {
        renderUpgrades();
        upgradeModal.classList.add('open');
      });
      document.getElementById('btn-upgrade-close').addEventListener('click', () => {
        upgradeModal.classList.remove('open');
      });
      upgradeModal.addEventListener('click', (e) => {
        if (e.target === upgradeModal) upgradeModal.classList.remove('open');
      });

      // 게임 시작 시 스테이지 정보 전달
      function startGame() {
        localStorage.setItem('porande-stage', String(selectedStage));
        overlay.classList.add('hidden');
      }
      document.getElementById('btn-guest-start').addEventListener('click', startGame);
      document.getElementById('btn-play-start').addEventListener('click', startGame);

      // UP 획득 폴링 (게임 중 UP 쌓이면 badge 업데이트)
      setInterval(() => { refreshUpBadge(); }, 2000);
    